import { render, staticRenderFns } from "./ComprehenDistributionChild.vue?vue&type=template&id=7288bb1e&scoped=true&"
import script from "./ComprehenDistributionChild.vue?vue&type=script&lang=js&"
export * from "./ComprehenDistributionChild.vue?vue&type=script&lang=js&"
import style0 from "./ComprehenDistributionChild.vue?vue&type=style&index=0&id=7288bb1e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7288bb1e",
  null
  
)

export default component.exports